import { render, staticRenderFns } from "./PresentationScreen.vue?vue&type=template&id=54fe365c&scoped=true"
import script from "./PresentationScreen.vue?vue&type=script&lang=js"
export * from "./PresentationScreen.vue?vue&type=script&lang=js"
import style0 from "./PresentationScreen.vue?vue&type=style&index=0&id=54fe365c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe365c",
  null
  
)

export default component.exports